import { ACTIONS, ALIAS, CATALOG_VERSION, DEFAULT_DISMISSAL_QUESTION, SURFACES, actions, array, boolean, cardRowSchema, cardState, catalog, checkDocument, components, describeCatalog, dismissalQuestionOf, dispatchCardAction, documentSchema, factsSchema, handledActions, isRecord, isRunNotCompleted, isRunRefused, isSpec, number, object, originOf, placeholderFor, platformOf, record, rowDeclaresChecks, string, surfacesOf, unknown, updatePromptDocument, viewFor, withoutUnhandledActions } from "./state-DJ-B6rrS.js";
//#region src/playground.ts
const cardStateSchema = object({
	fields: record(string(), unknown()),
	status: cardRowSchema.shape.status,
	error: object({
		message: string(),
		kind: string()
	}).nullable(),
	external_ref: record(string(), unknown()).nullable(),
	last_run: object({
		key: string(),
		at: string()
	}).nullable(),
	validation_errors: object({
		fields: record(string(), string()),
		card: string().nullable()
	}),
	title: string(),
	summary: string(),
	context: string().nullable(),
	kind: factsSchema.shape.kind.optional(),
	urgency: factsSchema.shape.urgency.optional(),
	origin: factsSchema.shape.origin.optional(),
	reason: factsSchema.shape.reason.optional(),
	project: factsSchema.shape.project.optional(),
	outcome: factsSchema.shape.outcome.optional(),
	primary_action: factsSchema.shape.primary_action.optional(),
	revoked_reason: factsSchema.shape.revoked_reason.optional(),
	created_at: factsSchema.shape.created_at.optional(),
	resolved_at: factsSchema.shape.resolved_at.optional(),
	dismissal: factsSchema.shape.dismissal.optional(),
	happens: factsSchema.shape.happens,
	open_url: factsSchema.shape.open_url,
	verb: factsSchema.shape.verb,
	run: factsSchema.shape.run,
	restore: factsSchema.shape.restore,
	dismissed_reason: factsSchema.shape.dismissed_reason,
	chat_started: factsSchema.shape.chat_started,
	chat_auto_started: factsSchema.shape.chat_auto_started
});
const playgroundActionSchema = object({
	key: string(),
	label: string(),
	running_label: string(),
	done_label: string(),
	finishes: boolean()
});
const playgroundExampleSchema = object({
	id: string(),
	label: string(),
	sample_only: array(string()),
	states: record(string(), cardStateSchema),
	channel_text: record(string(), array(string())),
	channel_envelope: record(string(), array(string()))
});
const playgroundSampleSchema = object({
	name: string(),
	provider: string(),
	actions: array(playgroundActionSchema),
	views: record(string(), unknown()),
	examples: array(playgroundExampleSchema).min(1)
});
const playgroundDataSchema = object({
	catalog_version: number(),
	highest_catalog_version: number().int(),
	types: array(playgroundSampleSchema)
});
//#endregion
export { ACTIONS, ALIAS, CATALOG_VERSION, DEFAULT_DISMISSAL_QUESTION, SURFACES, actions, cardRowSchema, cardState, cardStateSchema, catalog, checkDocument, components, describeCatalog, dismissalQuestionOf, dispatchCardAction, documentSchema, handledActions, isRecord, isRunNotCompleted, isRunRefused, isSpec, originOf, placeholderFor, platformOf, playgroundDataSchema, rowDeclaresChecks, surfacesOf, updatePromptDocument, viewFor, withoutUnhandledActions };

//# sourceMappingURL=index.js.map